import TablePagination from '../component/TablePagination';
import { brand } from "../config/brands";
import React, { useEffect, useRef, useState } from 'react';
import Layout from '../component/Layout';
import { ArrowUpTrayIcon,EllipsisVerticalIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { addBusiness, deleteBusiness, getAllPendingOrders, getAllSubCategories, getBusiness } from '../adapter/api';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ApiUrlService } from '../api-library/api-services';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { GoogleMap, LoadScript, Autocomplete, Marker, useLoadScript } from "@react-google-maps/api";
import "./Business.css";

const Business = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalAddOpen, setIsModalAddOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [discount, setDiscount] = useState(false);
  const [AsMarket, setAsMarket] = useState(false);
  const [allDay, setAllDay] = useState(false);
  const [orders, setBusiness] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [initialCategory, setInitialCategory] = useState(null);
  const [changeCat, setChangeCat] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [logo, setLogo] = useState("");
  const [image, setImage] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [email, setEmail] = useState("");
  const [priority, setPriority] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("30-45 min");
  const [discountPercentage, setDiscountPercentage] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [WhatsAppNumber, setWhatsAppNumber] = useState("");
  const [description, setDescription] = useState("");
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [location, setLocation] = useState({ lat: 33.8938, lng: 35.5018 }); // Default to Beirut, Lebanon
  const [autocomplete, setAutocomplete] = useState(null);

  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);
  const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);

  const apiUrlService = new ApiUrlService()


  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const [openingHours, setOpeningHours] = useState(
  daysOfWeek.map((dayOfWeek) => ({ dayOfWeek, openTime: null, closeTime: null , isClosed: null }))
);

const handleTimeChangee = (dayOfWeek, type, value) => {
  setOpeningHours((prev) =>
    prev.map((d) => (dayOfWeek === "Monday" || d.dayOfWeek === dayOfWeek ? { ...d, [type]: value } : d))
  );
};

const copyMondayToAll = () => {
  setOpeningHours((prev) => {
    const monday = prev.find(day => day.dayOfWeek === "Monday");
    return monday ? prev.map(day => ({ ...day, openTime: monday.openTime, closeTime: monday.closeTime, isClosed: monday.isClosed })) : prev;
  });
};

  



   // Inside the component function
const exportToPDF = () => {
  const doc = new jsPDF();
  
  // Adding title to PDF
  doc.text("Business", 20, 20);
  
  // Set up headers for the table
  const headers = ["#", "Name", "Email", "PhoneNumber", "Description","Category" ];
  
  // Create rows dynamically based on orders
  const rows = paginatedOrders.map(order => [
    order.restaurant_id,
    order.name,
    order.email,
    order.phoneNumber,
    order.description,
    order.subCategoryName
  ]);
  
  // Add the table to the PDF
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 30, // The Y position where the table starts
  });

  // Save the PDF to the local system
  doc.save("business.pdf");
};


  const [updatedLogo, setUpdatedLogo] = useState(null);
  const [updatedImage, setUpdatedImage] = useState(null);

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    if (type === "logo") {

      setUpdatedLogo(file);
      setLogo(file)
      handleImageChange(file, "logo")
    } else if (type === "image") {
      setUpdatedImage(file);
      setImage(file)
      handleImageChange(file, "image")
    }
  };

   // Derived states
   const filteredOrders = orders.filter((order) => {
    const search = searchTerm.toLowerCase();
    return (
      order.name?.toString().toLowerCase().includes(search) ||
      order.email?.toLowerCase().includes(search) ||
      order.description?.toString().toLowerCase().includes(search) ||
      order.subCategoryName?.toString().toLowerCase().includes(search) 
    );
  });

  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );


  const handleImageChange = async (image, name) => {
    if (image) {
      const formData = new FormData();
      formData.append("file", image);

      try {
        const response = await axios.post(
          `${brand.apiBaseUrl}/saveImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (name === "logo") {
          setUpdatedLogo(response.data.data);
          setLogo(response.data.data)
         
        } else {
          setUpdatedImage(response.data.data);
          setImage(response.data.data)
          
        }
      } catch (error) {
        console.error("Error uploading image:", error.message);
        toast.error("Failed to upload image.");
      }
    }
  };

  const getCategories = () => {
    setCategories([])
    var service = apiUrlService.GetApi()
    fetch(`${brand.apiBaseUrl}/category`, service).then(res => res.json())
      .then(response => {

        categories.length = 0
        for (var j = 0; j < response.data.length; j++) {
          const data = {
            label: response.data[j].name,
            value: response.data[j].categoryId
          }
          categories.push(data)
        }
        setCategories(categories);

      });
  }

  const getSubCategories = (categoryId) => {
    var service = apiUrlService.GetApi()
    fetch(`${brand.apiBaseUrl}/subByCategory?category=${categoryId}`, service)
      .then((res) => res.json())
      .then((response) => {
        const subCategoryOptions = response.data.map((subCategory) => ({
          label: subCategory.name,
          value: subCategory.subCategoryId,
        }));
        setSubCategories(subCategoryOptions);
      })
      .catch((error) => console.error("Error fetching subcategories:", error));
  };

  const handleDeleteClick = (item) => {
    toggleDropdown(null)
    setSelectedItem(item);
    setShowConfirmModal(true);

  };

  const handleDiscountChange = (e) => {
    setDiscount(e.target.checked); // Updates state based on checkbox status
  };

  const handleAllDayChange = (e) => {
    if(!e.target.checked){
      setFromTime("10:00:00")
      setToTime("10:00:00")
    }
   
    setAllDay(e.target.checked); // Updates state based on checkbox status
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    setSelectedCategory(selectedCategoryId);
    setSelectedSubCategory(null);  // Reset subcategory when category changes
    getSubCategories(selectedCategoryId);  // Fetch subcategories for selected category
  };

  const handleSaveBusiness = async () => {

     if(!allDay && (openingHours.length == 0)){
      toast.error("Please add opening hours!");
    }else{
      if(selectedCategory && phoneNumber  && businessName && description && logo && image ){
        const user = {
          email: email,
          phoneNumber:phoneNumber,
          whatsappNumber: WhatsAppNumber,
          firstName:businessName,
          lastName:null,
          roles:{
              role_id: "3"
          }
        };
    
        var service2 = apiUrlService.PostApi(user)
    
    
          fetch(`${brand.identityApiUrl}/user/save`, service2).then((response) => response.json())
                  .then(async (resp) => {
                    if(resp.status == 500){
                      toast.error("Number already Exist!")
                    }else{
                      if(selectedSubCategory && phoneNumber && WhatsAppNumber  && businessName && description && logo && image){

                        let openingHoursArray = [];
                        if (!allDay) {
                          
                            const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
                            openingHoursArray = openingHours.map((entry) => ({
                              dayOfWeek: entry.dayOfWeek,
                              openTime: entry.openTime, 
                              closeTime: entry.closeTime,
                              isClosed: entry.isClosed
                          }));
                        }

                        if(discount && !discountPercentage){
                          toast.error("Please add a percentage for the discount")
                        }else{
                          const response = await addBusiness(selectedSubCategory, phoneNumber,allDay, email,resp.data.pass, businessName, description, logo, image, location.lat,location.lng, deliveryTime, openingHoursArray,priority, AsMarket)
                        if (response.status) {
                        toast.success("Business Added!");
                        setIsModalAddOpen(false)
                        setSelectedCategory(null)
                        setPhoneNumber("")
                        setWhatsAppNumber("")
                        setEmail("")
                        setPriority("")
                        setBusinessName("")
                        setDescription("")
                        setLogo("")
                        setImage("")
                        setOpeningHours(daysOfWeek.map((dayOfWeek) => ({ dayOfWeek, openTime: null, closeTime: null, isClosed: null})))
                        handleGetBusiness()
                        getCategories()
  
                        }else{
                          toast.error("Error ! Please try again")
                        }
                        }
                        
                      }else{
                        toast.error("Please fill all required fields"); 
                      }
                 
                    }
                       
                    
                     
                    })
                  
                  
      }else{
        toast.error("Please fill all required fields"); 

      }
 
   
 
    
  }
}


  const handleGetBusiness = async () => {
    setBusiness([]);
    const response = await getBusiness()
    setBusiness(response.data.data)
  }


  const handleToggleClosed = (dayOfWeek) => {
    setOpeningHours(prevState => 
      prevState.map(item => 
        item.dayOfWeek === dayOfWeek ? { ...item, isClosed: !item.isClosed } : item
      )
    );
  };


  
  const handlePlaceSelect = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setLocation({ lat, lng });
        console.log('Latitude:', lat, 'Longitude:', lng);
      }
    }
  };


  useEffect(() => {
    handleGetBusiness()
    getCategories()
  }, []);

  const formatTo24Hour = (time) => {
    const [hour, minute, second] = time && time.split(':');
    let hours24 = parseInt(hour);

    // Convert 12-hour to 24-hour format
    if (hours24 < 12) {
      hours24 = hours24 === 12 ? 0 : hours24; // Handle 12 AM case
    } else if (hours24 > 12) {
      hours24 = hours24 === 12 ? 12 : hours24; // For 12 PM, no change needed
    }

    return (`${hours24.toString().padStart(2, '0')}:${minute.padStart(2, '0')}:${second ? second.padStart(2, '0') : '00'}`).replace(/AM|PM/, "");
  };


  useEffect(() => {
    if (selectedOrder) {
      setBusinessName(selectedOrder.name || "");
      setEmail(selectedOrder.email || "")
      setPriority(selectedOrder.priority || "")
      // Set from and to time with the 24-hour formatted time
      setFromTime(formatTo24Hour((selectedOrder.fromTime) || '10:00:00'));
      setToTime(formatTo24Hour((selectedOrder.toTime) || '10:00:00'));
      setPhoneNumber(selectedOrder.phoneNumber || "")
      setWhatsAppNumber(selectedOrder.whatsappNumber || "")
      setDescription(selectedOrder.description || "")
      setDiscount(selectedOrder.onOffer || false)
      setDiscountPercentage(selectedOrder.discountPercentage || "")
      setDeliveryTime( selectedOrder.deliveryTime || "30-45 min")
      setAllDay(selectedOrder.allHours || "")
      setAsMarket(selectedOrder.likeMarket || "")
      setInitialCategory(selectedOrder.subCategoryName  || null )
      setOpeningHours(selectedOrder.openingHours || daysOfWeek.map((dayOfWeek) => ({ dayOfWeek, openTime: null, closeTime: null, isClosed: null })))
      if (selectedOrder && selectedOrder.google_map_coordinates) {
        const lat = parseFloat(selectedOrder.google_map_coordinates.x);
        const lng = parseFloat(selectedOrder.google_map_coordinates.y);
    
        // Check if lat and lng are valid numbers
        if (lat && lng) {
          setLocation({ lat, lng });
        } else {
          console.error('Invalid coordinates:', lat, lng);
          // Optionally fallback to a default location if invalid
          setLocation({ lat: 33.8938, lng: 35.5018 });
        }
      }
    }
  }, [selectedOrder]);


  // Handle time change with seconds
  const handleTimeChange = (time, type) => {
    // Parse the time to 24-hour format if needed (handling time with or without seconds)
    const [hour, minute, seconds = '00'] = time && time.split(':');  // Default seconds to '00' if not provided

    const formattedTime = new Date();
    formattedTime.setHours(hour);
    formattedTime.setMinutes(minute);
    formattedTime.setSeconds(seconds);  // Ensure seconds are set (defaults to '00')

    // Format to 24-hour format with seconds
    const hours24 = formattedTime.getHours().toString().padStart(2, '0');
    const minutes = formattedTime.getMinutes().toString().padStart(2, '0');
    const formattedSeconds = formattedTime.getSeconds().toString().padStart(2, '0');  // Ensure seconds are included

    // Combine hours, minutes, and seconds
    const formattedTimeString = `${hours24}:${minutes}:${formattedSeconds}`;

    // Set the appropriate time based on the type ('from' or 'to')
    if (type === 'from') {
      setFromTime(formattedTimeString);
    } else if (type === 'to') {
      setToTime(formattedTimeString);
    }
  };




  const confirmDelete = () => {
   
    handleDeleteOrder(selectedItem);
  
  };

  const handleDeleteOrder = async (business) =>{
    try {

      const response = await deleteBusiness(business.restaurant_id);
      if (response.data.status) {

        toast.success("Business Deleted!");
        setShowConfirmModal(false)
        handleGetBusiness()
        getCategories()
  
    
      }
    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  }
  const cancelDelete = () => {
    setShowConfirmModal(false);
  };



  const handleEditItem = async (business) => {

    const response = await getAllSubCategories();

    const body =
    {
      "name": businessName,
      "phoneNumber": phoneNumber,
      "whatsappNumber": WhatsAppNumber,
      "email": email,
      "description": description,
      "logo": updatedLogo ? updatedLogo : business.logo,
      "image": updatedImage ? updatedImage : business.image,
      "fromTime": fromTime,
      "toTime": toTime,
      "onOffer": discount,
      "priority":priority,
      "discountPercentage": discountPercentage,
      "deliveryTime": deliveryTime,
      "acceptOrder": business.acceptOrder,
      "causeTitle":  business.causeTitle,
      "causeDesc": business.causeDesc,
      "openingHours": openingHours,
      "likeMarket": AsMarket,
      "google_map_coordinates":{
        "x": location.lat,
        "y": location.lng
    },
      subCategory: {
        subCategoryId: selectedSubCategory 
          ? selectedSubCategory 
          : response.data.data.find((x) => x.name === initialCategory)?.subCategoryId, // Handle fallback and null safety
      }
    }

    if(discount && !discountPercentage){
      toast.error("Please add a percentage for the discount")
    }else{

    var service = apiUrlService.PutApi(body)
    fetch(`${brand.apiBaseUrl}/restaurant/` + business.restaurant_id + '', service).then((response) => response.json())
      .then((response) => {

        if (response.status === true) {
          toast.success("Business Updated!");
          setIsModalOpen(false)
          setChangeCat(false)
          handleGetBusiness()
        }
      })
    }
  };

  const handleDeleteItem = (index) => {
    console.log("Delete item at index:", index);
    // Implement the logic to delete the item
    // For example, you can update the items array:
    const updatedItems = selectedOrder.items.filter((_, i) => i !== index);
    setSelectedOrder({ ...selectedOrder, items: updatedItems });
  };


  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedOrder(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCategory(null)
    setPhoneNumber("")
    setWhatsAppNumber("")
    setEmail("")
    setPriority("")
    setBusinessName("")
    setDescription("")
    setChangeCat(false)
    setLogo("")
    setImage("")
    setFromTime('')
    setToTime('')
    setIsModalAddOpen(false)
    setSelectedOrder(null); // Clear selected order when closing the modal
    setOpeningHours(daysOfWeek.map((dayOfWeek) => ({ dayOfWeek, openTime: null, closeTime: null, isClosed: null})))
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };



  const openAddModal = () => {
    setIsModalAddOpen(true)
   
  }

    const scriptRef = useRef(null); // Ref to track the script
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const libraries = ['places'];

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
    libraries,
  });


  return (
    <Layout>
      <ToastContainer />
      <h1 className="text-2xl font-medium mb-4 mt-7 font-inter text-lg">Businesses</h1>
      {/* Page content goes here */}
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      <div className="data-card overflow-x-auto mt-4 rounded-lg">
        <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
          <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search business…" aria-label="Search business"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
          </div>

          <div className="npb-3 flex">
            <button onClick={() => openAddModal()}
              className="mr-5 px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <PlusIcon className="h-4 w-4 mr-2 mt-0.4" />
              New Business
            </button>
            <button onClick={exportToPDF}
              className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
              Export
            </button>
          </div>
        </div>
        <table className="data-table  min-w-full bg-white border-b border-r border-l border-gray-200 shadow-sm">
          <thead>
            <tr className="bg-grey border-b">
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700"></th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Name</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Phone Number</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Password</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Description</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">SubCategory</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Logo</th>
            </tr>
          </thead>
          <tbody>
            {paginatedOrders.map((order) => (
              <tr
                key={order.id}
                className="border-b hover:bg-gray-50"
              >
                <td
                  className="px-4 py-3 text-sm text-yellow font-inter cursor-pointer"

                >
                  <EllipsisVerticalIcon className="h-5 w-5 mr-2"
                    onClick={() => toggleDropdown(order.restaurant_id)}
                  />
                  {dropdownOpenId === order.restaurant_id && (
                    <div className="absolute bg-white shadow rounded p-2" style={{ width: "10%" }}>
                      <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={() => openModal(order)}>Edit</button>
                      <hr className="w-full border-gray-200 my-2" />
                      <button className="block w-full text-left px-2 py-1 text-red-600 hover:text-yellow text-gray-700" onClick={() => handleDeleteClick(order)}>Delete</button>
                    </div>
                  )}
                </td>
                <td  className=" mt-5 flex px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.name} 
                {order.onOffer &&  <div className="badge-container">
      <div className="badge">
        <div style={{fontSize:10, color:"white"}}>
          {order.discountPercentage}%
        </div>
      </div>
    </div>}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.phoneNumber}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.password}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.description}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.subCategoryName}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                <img
                    src={order.logo}
                    alt={order.name}
                    className="w-16 h-16 rounded-lg object-cover mr-4"
                  />
                </td>
              </tr>
            ))}

          </tbody>
        </table>
         {/* Pagination */}
      <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      <div className="data-endcap">
       
       

 {/* Modal */}
{isModalOpen && selectedOrder && (
  <div className="business-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div className="business-modal-panel bg-white w-full rounded-lg shadow-lg p-6 max-h-[80vh] overflow-y-auto">
      <h2 className="text-lg font-semibold mb-4">Business Details</h2>
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Name Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
          />
        </div>

        {/* Phone Number Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp Number</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={WhatsAppNumber}
            onChange={(e) => setWhatsAppNumber(e.target.value)}
          />
        </div>

        {/* Email Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          />
        </div>

        <div className="flex items-center">
          <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">As Market?</label>
          <input
            type="checkbox"
            checked={AsMarket}
            onChange={(e) => setAsMarket(e.target.checked)}
            className="h-4 p-2 ml-2 w-4 text-blue-600 border-gray-300 rounded"
          />
        </div>

        {/* Discount Checkbox */}
        <div className="flex items-center">
          <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Discount?</label>
          <input
            type="checkbox"
            checked={discount}
            onChange={handleDiscountChange}
            className="h-4 p-2 ml-2 w-4 text-blue-600 border-gray-300 rounded"
          />
        </div>

        {/* Discount Percentage Input */}
        {discount && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1 w-1/3">Discount (%)</label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
              value={discountPercentage}
              onChange={(e) => setDiscountPercentage(e.target.value)}
            />
          </div>
        )}

        {/* Description Textarea */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
          <textarea
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            rows="3"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          ></textarea>
        </div>

        {/* Delivery Time Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Delivery Time</label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={deliveryTime}
            onChange={(e) => setDeliveryTime(e.target.value)}
          />
        </div>

        {/* 24 Hours Checkbox */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">24 hours?</label>
          <input
            type="checkbox"
            checked={allDay}
            onChange={handleAllDayChange}
            className="h-4 p-2 ml-2 w-4 text-blue-600 border-gray-300 rounded"
          />
        </div>

        {/* Opening Hours Section */}
        {!allDay && (
  <div className="business-hours-panel md:col-span-2">
    <div className="business-hours-heading"><div><h3>Opening hours</h3><p>Set Monday once, then adjust individual days only when needed.</p></div><button type="button" onClick={copyMondayToAll}>Copy Monday to all</button></div>
    {openingHours
    .slice()
    .sort((a, b) => daysOfWeek.indexOf(a.dayOfWeek) - daysOfWeek.indexOf(b.dayOfWeek))
    .map((item, index) => (
      <div key={index} className="flex items-center gap-4 mb-2">
        <span className="w-1/4 text-gray-700">{item.dayOfWeek}</span>
        

          <div className="flex gap-2 w-1/4">
            <input type="time" value={(item.openTime || '').slice(0, 5)} onChange={(e) => handleTimeChangee(item.dayOfWeek, "openTime", e.target.value)} className="business-settings-time" aria-label={`${item.dayOfWeek} opening time`} />
            <span className="text-gray-700">to</span>
            <input type="time" value={(item.closeTime || '').slice(0, 5)} onChange={(e) => handleTimeChangee(item.dayOfWeek, "closeTime", e.target.value)} className="business-settings-time" aria-label={`${item.dayOfWeek} closing time`} />
          </div>
        
      </div>
    ))}
  </div>
)}


        {/* Category Selection */}
        {changeCat && (
          <div>
            <label htmlFor="category" className="font-inter text-sm text-gray-700">Category</label>
            <select
              id="category"
              value={selectedCategory}
              onChange={handleCategoryChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a category</option>
              {categories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {!changeCat && initialCategory && (
          <div className="flex" style={{height:"27%"}}>
            <label htmlFor="subCategory" className="font-inter text-sm text-gray-700">
              <span className="font-bold">Category:</span> {initialCategory}
            </label>
            <button
          onClick={() => setChangeCat(true)}
          className="px-4 py-2 bg-yellow text-white rounded-lg hover:bg-customColor ml-5"
        >
              Change
            </button>
          </div>
        )}

        {/* SubCategory Selection */}
        {changeCat && selectedCategory && (
          <div>
            <label htmlFor="subCategory" className="font-inter text-sm text-gray-700">SubCategory</label>
            <select
              id="subCategory"
              value={selectedSubCategory}
              onChange={(e) => setSelectedSubCategory(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a subcategory</option>
              {subCategories.map((subCategory) => (
                <option key={subCategory.value} value={subCategory.value}>
                  {subCategory.label}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Logo and Image Upload */}
        <div className="flex justify-between">
          <div className="w-1/2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Logo</label>
            <img
              src={selectedOrder.logo}
              alt={selectedOrder.name}
              className="w-16 h-16 rounded-lg object-cover mb-2"
            />
            <input
              type="file"
              accept="image/*"
              className="block w-full mb-4"
              onChange={(e) => handleFileChange(e, "logo")}
            />
          </div>

          <div className="w-1/2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Background Image</label>
            <img
              src={selectedOrder.image}
              alt={selectedOrder.name}
              className="w-full h-16 rounded-lg object-cover mb-2"
            />
            <input
              type="file"
              accept="image/*"
              className="block w-full mb-4"
              onChange={(e) => handleFileChange(e, "image")}
            />
          </div>
        </div>
        <div className="business-location-panel md:col-span-3">
          <label>Search location</label>
          {isLoaded && (
            <Autocomplete onLoad={(auto) => setAutocomplete(auto)} onPlaceChanged={handlePlaceSelect}
              options={{ componentRestrictions: { country: "LB" } }}>
              <input type="text" placeholder="Search for a location" className="business-location-search w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </Autocomplete>
          )}
           {isLoaded && ( <GoogleMap
        center={location}  // Use location state here to set the center of the map
        zoom={14}
        mapContainerStyle={{ height: "200px", width: "100%" }} mapContainerClassName="business-map"
      >
        <Marker position={location} />  {/* Marker will be placed at the selected coordinates */}
      </GoogleMap>)}
        </div>
      </div>

      <div className="mt-4 flex justify-end">
        <button
          onClick={closeModal}
          className="px-4 py-2 bg-gray-400 text-white rounded-lg mr-2 hover:bg-gray-500"
        >
          Cancel
        </button>
        <button
          onClick={() => handleEditItem(selectedOrder)}
          className="px-4 py-2 bg-yellow text-white rounded-lg hover:bg-customColor"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}


{isModalAddOpen && (
  <div className="business-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="business-modal-panel bg-white w-full rounded-lg shadow-lg p-6 max-h-[80vh] overflow-y-auto">
      <h2 className="text-lg font-semibold mb-4">Business Details</h2>
      <hr className="w-full border-gray-300 my-3" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={businessName} onChange={(e) => setBusinessName(e.target.value)} />
        </div>

        {/* Phone Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">WhatsApp Number</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={WhatsAppNumber} onChange={(e) => setWhatsAppNumber(e.target.value)} />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={priority} onChange={(e) => setPriority(e.target.value)} />
        </div>

        {/* Description */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
          <textarea className="w-2/3 px-3 py-2 border border-gray-300 rounded-lg mb-4" rows="3"
            value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
        </div>

        {/* Delivery Time */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Delivery Time</label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
            value={deliveryTime} onChange={(e) => setDeliveryTime(e.target.value)} />
        </div>

        {/* 24 Hours Checkbox */}
        <div className="flex items-center space-x-2">
          <input type="checkbox" checked={allDay} onChange={handleAllDayChange} className="h-4 w-4 text-blue-600 border-gray-300 rounded" />
          <label className="text-sm font-medium text-gray-700">24 hours?</label>
        </div>

        <div className="flex items-center space-x-2">
          <input type="checkbox" checked={AsMarket} onChange={(e) => setAsMarket(e.target.checked)} className="h-4 w-4 text-blue-600 border-gray-300 rounded" />
          <label className="text-sm font-medium text-gray-700">As Market?</label>
        </div>


        {/* Opening Hours (Conditional) */}
        {!allDay && (
  <div className="business-hours-panel md:col-span-2">
    <div className="business-hours-heading"><div><h3>Opening hours</h3><p>Set Monday once, then adjust individual days only when needed.</p></div><button type="button" onClick={copyMondayToAll}>Copy Monday to all</button></div>
    {openingHours
    .slice()
    .sort((a, b) => daysOfWeek.indexOf(a.dayOfWeek) - daysOfWeek.indexOf(b.dayOfWeek))
    .map((item, index) => (
      <div key={index} className="flex items-center gap-4 mb-2">
        <span className="w-1/4 text-gray-700">{item.dayOfWeek}</span>
        
     
          <div className="flex gap-2 w-1/4">
            <input type="time" value={(item.openTime || '').slice(0, 5)} onChange={(e) => handleTimeChangee(item.dayOfWeek, "openTime", e.target.value)} className="business-settings-time" aria-label={`${item.dayOfWeek} opening time`} />
            <span className="text-gray-700">to</span>
            <input type="time" value={(item.closeTime || '').slice(0, 5)} onChange={(e) => handleTimeChangee(item.dayOfWeek, "closeTime", e.target.value)} className="business-settings-time" aria-label={`${item.dayOfWeek} closing time`} />
          </div>
        
      </div>
    ))}
  </div>
)}


        {/* Category Dropdown */}
        <div className="md:col-span-3">
        
          <select id="category" value={selectedCategory} onChange={handleCategoryChange}
            className="w-1/3 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
            <option value="">Select a category</option>
            {categories.map((category) => (
              <option key={category.value} value={category.value}>{category.label}</option>
            ))}
          </select>
        </div>

        {/* Subcategory Dropdown */}
        {selectedCategory && (
          <div className="md:col-span-3">
           
            <select id="subCategory" value={selectedSubCategory} onChange={(e) => setSelectedSubCategory(e.target.value)}
              className="w-1/3 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
              <option value="">Select a subcategory</option>
              {subCategories.map((subCategory) => (
                <option key={subCategory.value} value={subCategory.value}>{subCategory.label}</option>
              ))}
            </select>
          </div>
        )}

        {/* Logo Upload */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Logo</label>
          <img src={logo} alt={businessName} className="w-16 h-16 rounded-lg object-cover mb-2" />
          <input type="file" accept="image/*" className="block w-full mb-4" onChange={(e) => handleFileChange(e, "logo")} />
        </div>

        {/* Background Image Upload */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-gray-700 mb-1">Background Image</label>
          <img src={image} alt={businessName} className="w-20 h-16 rounded-lg object-cover mb-2" />
          <input type="file" accept="image/*" className="block w-full mb-4" onChange={(e) => handleFileChange(e, "image")} />
        </div>

        {/* Location Search */}
        <div className="business-location-panel md:col-span-3">
          <label>Search location</label>
          {isLoaded && (
            <Autocomplete onLoad={(auto) => setAutocomplete(auto)} onPlaceChanged={handlePlaceSelect}
              options={{ componentRestrictions: { country: "LB" } }}>
              <input type="text" placeholder="Search for a location" className="business-location-search w-full px-3 py-2 border border-gray-300 rounded-lg" />
            </Autocomplete>
          )}
          <GoogleMap center={location} zoom={14} mapContainerStyle={{ height: "200px", width: "100%" }} mapContainerClassName="business-map">
            <Marker position={location} />
          </GoogleMap>
        </div>
      </div>

      {/* Buttons */}
      <div className="mt-4 flex justify-end space-x-2">
        <button onClick={() => setIsModalAddOpen(false)} className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500">
          Cancel
        </button>
        <button
          onClick={() => handleSaveBusiness()}
          className="px-4 py-2 bg-yellow text-white rounded-lg hover:bg-customColor"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}


 {/* Confirmation Modal */}
 {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this business?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                onClick={cancelDelete}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    </Layout>
  );
};

export default Business;
